<template>
  <div class="content-ct">
    <el-row>
      <el-col :xs="9" :sm="9" :md="8" :lg="6">
        <game-campaign-content-nav
          :menu-items="previewNavigation"
          :default-active="activeItemTitle"
          @update="setActiveItem"
          data-qa="preview-game-campaign-content-nav"
        />
      </el-col>
      <el-col :xs="15" :sm="15" :md="16" :lg="18">
        <component
          v-if="activeItem"
          :is="activeItem.component"
          :is-creation-mode="isCreationMode"
          :is-read-only="isReadOnly"
          :save-flag="saveFlag"
          @check="$emit('check', $event)"
          :data-qa="`game-campaign-content-component-${activeItemTitle}`"
          :game-campaign-id="gameCampaignId"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import GameCampaignContentNav from '@/modules/gamification/components/games-campaigns/GameCampaignContentNav.vue'
import GamePreviewSubStep from '@/modules/gamification/components/games-campaigns/preview/common/GamePreviewSubStep.vue'
import GameLaunchSubStep from '@/modules/gamification/components/games-campaigns/preview/common/GameLaunchSubStep.vue'
import { GameCreationSubSteps } from '@/modules/gamification/enum/GameCreationStepsEnum.js'

export default {
  name: 'GameStepPreview',
  components: {
    GameCampaignContentNav,
    GamePreviewSubStep,
    GameLaunchSubStep
  },
  props: {
    isCreationMode: {
      type: Boolean,
      required: true
    },
    isReadOnly: {
      type: Boolean,
      required: true
    },
    saveFlag: {
      type: Boolean,
      required: true
    },
    gameCampaignId: {
      type: Number
    }
  },
  data() {
    return {
      activeItem: null,
      navigation: [
        {
          title: this.$t('Gamification_GameStepPreview_Preview'),
          step: GameCreationSubSteps.PREVIEW,
          component: GamePreviewSubStep
        },
        {
          title: this.$t('Gamification_GameStepPreview_Launch'),
          step: GameCreationSubSteps.LAUNCH,
          component: GameLaunchSubStep
        }
      ]
    }
  },
  computed: {
    previewNavigation() {
      return this.navigation
    },
    activeItemTitle() {
      return this.activeItem ? this.activeItem.title : null
    }
  },
  mounted() {
    this.$emit('checkChanges', false)
    this.activeItem = this.previewNavigation[0]
  },
  methods: {
    setActiveItem(tab) {
      this.activeItem = tab
    }
  }
}
</script>

<style scoped>
.content-ct {
  padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/pages/GameStepPreview.vue